import React from 'react';
import Modal from 'components/UI/Modal';
import ProductBadge from 'data/ProductBadge';
import {
  DEACTIVATE_BADGE_TITLE,
  DEACTIVATE_BADGE_MESSAGE,
  DEACTIVATE_BADGE_CONFIRM,
  DEACTIVATE_BADGE_CANCEL
} from 'constants/productBadges';
import { Main } from 'styles/themeColors';

interface Props {
  badge: ProductBadge | null;
  isDeactivating: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeactivateBadgeModal = ({ badge, isDeactivating, onClose, onConfirm }: Props) => (
  <Modal
    showModal={!!badge}
    onClose={onClose}
    onClick={onConfirm}
    title={DEACTIVATE_BADGE_TITLE}
    primaryButtonText={DEACTIVATE_BADGE_CONFIRM}
    ghostButtonText={DEACTIVATE_BADGE_CANCEL}
    primaryButtonColor={Main.brandDark}
    color={Main.black}
    borderColor={Main.disabled}
    disabled={isDeactivating}
    ghostButtonDisabled={isDeactivating}
    width="640px"
    left="28vw"
  >
    <p>{DEACTIVATE_BADGE_MESSAGE}</p>
  </Modal>
);

export default DeactivateBadgeModal;